import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01aba9cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "addModuleModal",
  tabindex: "-1",
  "data-bs-backdrop": "true",
  "aria-labelledby": "addModuleModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Add module", -1))
const _hoisted_6 = {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  ref: "closeBtn"
}
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Give your modul a name - A modul is a collection of descriptive text and tasks that are grouped together. Naming the modul will help identify its purpose.", -1))
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "Miletsone")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: ""
}, "Select a milestone", -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "Module title")
], -1))
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "AI Prompt")
], -1))
const _hoisted_17 = { class: "modal-footer" }
const _hoisted_18 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_19 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", _hoisted_6, null, 512)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedStepId) = $event))
            }, [
              _hoisted_11,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.milestones, (milestone) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: milestone.stepId,
                  value: milestone.stepId
                }, _toDisplayString(milestone.name), 9, _hoisted_12))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedStepId]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "name",
              placeholder: "Social Media Post",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
              onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _withDirectives(_createElementVNode("textarea", {
              type: "text",
              class: "form-control",
              id: "name",
              rows: "6",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.aiPrompt) = $event)),
              placeholder: "Write a standard operating procedure for a new vendor in relation to the data privacy agreement. Please also use a form to record the cookies used and another to record the sub processors."
            }, null, 512), [
              [_vModelText, _ctx.aiPrompt]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          (_ctx.showAiWaitingPrompt)
            ? (_openBlock(), _createElementBlock("p", _hoisted_18, " Unfortunately it can take up to 2 minutes until the module with the AI generated content is created. We will send you an email once it is ready. "))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary ms-2",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
            disabled: !_ctx.name.length || _ctx.submitted
          }, _toDisplayString(_ctx.submitted ? "Creating" : "Create"), 9, _hoisted_19)
        ])
      ])
    ])
  ]))
}